export function resolveNotificationTarget(notification) {
  const moduleCode = notification?.module_code || "";
  const title = String(notification?.title || "").toLowerCase();
  const message = String(notification?.message || "").toLowerCase();
  const referenceId = notification?.reference_id || null;

  if (!moduleCode) return null;

  if (moduleCode === "hrm.on_leave") {
    return {
      path: "/hrm/on_leave",
      targetType: "pending",
      referenceId,
      moduleCode,
    };
  }

  if (moduleCode === "hrm.overtime") {
    let targetType = "pending";
    if (
      title.includes("chờ đánh giá") ||
      title.includes("đánh giá thành công") ||
      title.includes("tăng ca hoàn tất") ||
      message.includes("đã gửi báo cáo tăng ca")
    ) {
      targetType = "review";
    } else if (
      title.includes("đã duyệt tăng ca") ||
      title.includes("phiếu tăng ca cập nhật") ||
      title.includes("đã duyệt tăng ca") ||
      message.includes("vui lòng gửi báo cáo")
    ) {
      targetType = "running";
    }

    return {
      path: "/hrm/overtime",
      targetType,
      referenceId,
      moduleCode,
    };
  }

  if (moduleCode === "hrm.tasks") {
    let targetType = "waiting";
    // Chỉ mở popup "đã báo cáo / duyệt báo cáo" khi đúng ngữ cảnh người duyệt — tránh khớp nhầm
    // tiêu đề kiểu "Báo cáo công việc được duyệt" (gửi cho nhân viên).
    const isReportApprovalFlow =
      title.includes("cần duyệt báo cáo") ||
      title.includes("duyệt báo cáo công việc") ||
      message.includes("đã gửi báo cáo công việc");
    if (isReportApprovalFlow) {
      targetType = "reported";
    } else if (
      title.includes("được giao") ||
      title.includes("được duyệt hoàn tất") ||
      title.includes("đã được duyệt hoàn tất") ||
      title.includes("báo cáo công việc được duyệt")
    ) {
      targetType = "approved";
    }

    return {
      path: "/hrm/tasks",
      targetType,
      referenceId,
      moduleCode,
    };
  }

  if (moduleCode === "finance.salary") {
    return {
      path: "/finance/salary",
      targetType: "detail",
      referenceId,
      moduleCode,
    };
  }

  if (moduleCode === "hrm.my_payslip") {
    return {
      path: "/hrm/my_payslip",
      targetType: "self",
      referenceId,
      moduleCode,
    };
  }

  if (moduleCode === "hrm.signing") {
    return {
      path: "/hrm/signing",
      targetType: "detail",
      referenceId,
      moduleCode,
    };
  }

  return null;
}
